export default {
  cards: {
    map: {
      content: {
        title: "Peta Sebaran",
        showTitle: true,
        subtitle: "Indeks Karakter Siswa",
        showSubtitle: true,
        showIcon: false,
        info: "#### Menunjukan sebaran peta",
        showInfo: true,
        showSaveAsImage: false,
        showTable: false,
        showDownloadTable: false,
      },
    },
    legend: {
      content: {
        title: "Legend",
        showTitle: true,
        showSubtitle: false,
        showIcon: false,
        info: "#### Menunjukan legenda dari peta",
        showInfo: true,
        showSaveAsImage: false,
        showTable: false,
        showDownloadTable: false,
      },
    },
    chart: {
      indeksKarakter: {
        content: {
          title: "Grafik Indeks Karakter Siswa Tahun 2020",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan grafik indeks karakter",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          chartOption: {
            grid: {
              top: 20,
              left: 60,
              right: 30,
              bottom: 70,
            },
            tooltip: {
              trigger: "axis",
            },
            dataset: [
              {
                dimensions: ["Provinsi", "Total"],
              },
              {
                transform: {
                  type: "sort",
                  config: { dimension: "Total", order: "desc" },
                },
              },
            ],
            xAxis: [
              {
                type: "category",
                axisLabel: {
                  rotate: 60,
                  formatter: (value) => {
                    return value.split(" ").join("\n");
                  },
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                interval: 1,
                min: 60,
              },
            ],
            series: {
              type: "bar",
              datasetIndex: 1,
              itemStyle: {
                normal: {
                  color: (params) => {
                    const colorList = ["#1B6FBA", "#FFCD56"];
                    return colorList[params.dataIndex % 2 === 0 ? 0 : 1];
                  },
                },
              },
              markLine: {
                data: [{ name: "Nasional", yAxis: 25 }],
              },
            },
          },
          columns: [
            {
              title: "Provinsi",
              dataIndex: "provinsi",
              sorter: (a, b) => a.provinsi.localeCompare(b.provinsi),
            },
            {
              title: "Nilai",
              dataIndex: "indeks",
              sorter: (a, b) => a.indeks - b.indeks,
            },
          ],
          dataSource: [],
          style: {
            height: 720,
          },
        },
        state: {},
      },
    },
  },
};
